var selectors = {
  body: 'body',
  html: 'html',
  drawerWrappper: '[data-drawer]',
  underlay: '[data-drawer-underlay]',
  stagger: '[data-stagger-animation]',
  wrapper: '[data-header-transparent]',
  transparent: 'data-header-transparent',
  drawerToggle: 'data-drawer-toggle',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
};

var classes = {
  isVisible: 'drawer--visible',
};

var sections = {};

class Drawer {
  constructor(el) {
    this.drawer = el;
    this.underlay = this.drawer.querySelector(selectors.underlay);
    this.wrapper = this.drawer.closest(selectors.wrapper);
    this.transparent = this.wrapper.getAttribute(selectors.transparent) !== 'false';
    this.key = this.drawer.dataset.drawer;
    const btnSelector = `[${selectors.drawerToggle}='${this.key}']`;
    this.buttons = document.querySelectorAll(btnSelector);
    this.staggers = this.drawer.querySelectorAll(selectors.stagger);
    this.body = document.querySelector(selectors.body);
    this.html = document.querySelector(selectors.html);

    this.connectToggle();
    this.connectDrawer();
    this.closers();
    this.staggerChildAnimations();
  }

  connectToggle() {
    this.buttons.forEach((btn) => {
      btn.addEventListener(
        'click',
        function () {
          this.drawer.dispatchEvent(
            new CustomEvent('theme:menu:toggle', {
              bubbles: false,
            })
          );
        }.bind(this)
      );
    });
  }

  connectDrawer() {
    this.drawer.addEventListener(
      'theme:menu:toggle',
      function () {
        if (this.drawer.classList.contains(classes.isVisible)) {
          this.hideDrawer();
        } else {
          this.showDrawer();
        }
      }.bind(this)
    );

    this.html.addEventListener('cart:open', () => {
      this.hideDrawer();
    });
  }

  staggerChildAnimations() {
    this.staggers.forEach((el) => {
      const children = el.querySelectorAll(':scope > * > [data-animates]');
      children.forEach((child, index) => {
        child.style.transitionDelay = `${index * 50 + 10}ms`;
      });
    });
  }

  watchFocus(evt) {
    let drawerInFocus = this.wrapper.contains(evt.target);
    if (!drawerInFocus) {
      this.hideDrawer();
    }
  }

  closers() {
    this.drawer.addEventListener(
      'keyup',
      function (evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.hideDrawer();
        this.buttons[0].focus();
      }.bind(this)
    );

    this.underlay.addEventListener(
      'click',
      function () {
        this.hideDrawer();
      }.bind(this)
    );
  }

  showDrawer() {
    this.transparent = this.wrapper.getAttribute(selectors.transparent) !== 'false';
    this.buttons.forEach((el) => el.setAttribute('aria-expanded', true));
    this.buttons.forEach((el) => el.classList.add(classes.isVisible));
    this.drawer.classList.add(classes.isVisible);
    this.drawer.querySelector(selectors.focusable).focus();
    this.wrapper.setAttribute(selectors.transparent, false);
    document.addEventListener('focusin', this.watchFocus.bind(this));

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
    }, 20);
  }

  hideDrawer() {
    this.buttons.forEach((el) => el.setAttribute('aria-expanded', true));
    this.buttons.forEach((el) => el.classList.remove(classes.isVisible));
    this.drawer.classList.remove(classes.isVisible);
    this.wrapper.setAttribute(selectors.transparent, this.transparent);
    document.removeEventListener('focusin', this.watchFocus);

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  }
}

const drawer = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.drawerWrappper);
    els.forEach((el) => {
      sections[this.id].push(new Drawer(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export default drawer;
